import { useTranslation } from "react-i18next";
import ScforhWhoCapsule from "./ScforhWhoCapsule";
import ScforhDimensionStatus from "./ScforhDimensionStatus";
import { isScforhSeedComplete } from "../constants/scforhClubHealth";
import { openDigitalTwin } from "./HomeDailyFocus";
import { currentAppLanguage } from "../utils/appLanguages";
import "./ParentProfilePanel.css";

/**
 * Admin-only profile: club health status (S C for H).
 */
export default function AdminProfilePanel({ user, scforhSeed, clubScforhSmart }) {
  const { t, i18n } = useTranslation();
  const lang = currentAppLanguage(i18n);

  const scforhSeedChips = [];
  if (scforhSeed?.sportingAims) scforhSeedChips.push(String(scforhSeed.sportingAims).slice(0, 80));
  if (Array.isArray(scforhSeed?.targetGroups)) {
    scforhSeed.targetGroups.slice(0, 3).forEach((g) => scforhSeedChips.push(String(g)));
  }

  return (
    <div className="parent-profile-panel admin-profile-panel">
      <div
        className="parent-profile-scforh club-health-card ios-objectives-card"
        data-tour-id="admin-profile-smart"
      >
        <div className="ios-objectives-header">
          <span>💚</span>
          <h3>{t("clubForHealthTitle")}</h3>
        </div>
        {scforhSeed?.targetGroups?.length || scforhSeed?.sportingAims || scforhSeed?.currentOffer ? (
          <ScforhDimensionStatus seed={scforhSeed} />
        ) : null}
        {isScforhSeedComplete(scforhSeed) && scforhSeedChips.length ? (
          <div className="club-health-chips">
            {scforhSeedChips.map((label, idx) => (
              <span key={`${idx}-${label}`} className="club-health-chip">
                {label}
              </span>
            ))}
          </div>
        ) : (
          <p className="club-health-empty">{t("clubForHealthEmpty")}</p>
        )}
        <div className="club-health-letters" aria-label="S M A R T">
          {["S", "M", "A", "R", "T"].map((letter) => {
            const st = clubScforhSmart?.status?.[letter] || "empty";
            return (
              <span key={letter} className={`club-health-letter club-health-letter--${st}`}>
                {letter}
              </span>
            );
          })}
        </div>
        <button
          type="button"
          className="club-health-cta"
          onClick={() =>
            openDigitalTwin({
              home_role: "admin",
              seedMessage: t("digipingClubScforhHomeSeed", { lng: lang }),
              seedVisible: false,
              profilingIntro: "clubScforh",
              seedKey: "digipingClubScforhHomeSeed",
            })
          }
        >
          {t("clubForHealthContinue")}
        </button>
        <details className="parent-profile-scforh-expand">
          <summary>
            {t("whoCapsuleEyebrow") || "WHO · Sports Club for Health"}
          </summary>
          {scforhSeed?.targetGroups?.length ? (
            <ScforhWhoCapsule targetGroups={scforhSeed.targetGroups} variant="compact" />
          ) : (
            <ScforhWhoCapsule bands={["youth", "adults", "seniors"]} variant="compact" />
          )}
        </details>
      </div>
    </div>
  );
}
